import { render, staticRenderFns } from "./faq-questions-answers.vue?vue&type=template&id=2f9f4e0c&"
import script from "./faq-questions-answers.vue?vue&type=script&lang=js&"
export * from "./faq-questions-answers.vue?vue&type=script&lang=js&"
import style0 from "./faq-questions-answers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports